<template>
    <!-- Modal -->
    <b-modal id="modalRoulette" hide-footer hide-header centered class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalRouletteTitle" aria-hidden="true" ref="modalRoulette">
        <!-- Close -->
        <b-button v-if=" !isDisabled " class="m-modalInfo__close" block @click="closeModal()"><span class="icon"></span></b-button>

        <!-- Content -->
        <div class="modal-body o-modalRoulette">
            <div class="m-modalRoulette__footer d-flex">
                <!--<roulette />                        -->

                <section class="section">

                    <div class="rouletteContainer">

                        <h2 class="m-modalRoulette__name text-center">Vyskúšaj šťastie</h2>

                        <div>
                            <img src="assets/img/ruleta/backgroundRuleta.png">
                            <canvas ref="ruletaCanvas" width="516" height="549"></canvas>
                            <img src="assets/img/ruleta/sipkaRuleta.png">
                        </div>

                    </div>

                    <form>
                        <!-- Alert box -->
                        <div v-if="responseText != ''" :class="'alert alert-'+responseType" role="alert">
                            <span :class="'icon --'+responseType"></span>{{ responseText }}
                        </div>  

                        <!-- Reward box -->
                        <template v-if="reward_text != ''">
                            <span>
                                <h3 class="mb-0 greenColor">Dokrútené!</h3>
                                <p class="rouletteWinText">{{ reward_text }} <span class="prize">{{ reward_nazov }} {{ reward_kusov }}</span></p>
                            </span>
                            <button @click="closeModal()" class="btn --primary">POKRAČOVAŤ</button>
                        </template>

                        <button v-if=" !isDisabled " @click="spinRuleta" class="btn --primary">ROZTOČIŤ KOLESO</button>

                    </form>

                </section>
            </div>
        </div>

    </b-modal>

</template>

<script>
    import EventService from '@/services/EventService.js'
    export default {
        props: [
            'profil'
        ],
        mounted() {
            this.$bvModal.show('modalRoulette')
            this.getRuleta()
        },
        data() {
            return {
                options: [],

                reward_text: '',
                reward_nazov: '',
                reward_kusov: '',

                isDisabled: false,

                canvas: {},
                ctx: {},
                ruletaWheel: {},
                ruletaInterval: {},

                currentAngle: 0,
                endAngle: 0,

                responseType: '',
                responseText: ''
            }
        },
        computed: {
            min() { return 360 },
            max() { return 3600 },
            fps() { return 1000 / 40 },
            generateRandomAngle() { return Math.round( Math.random() * ( this.max - this.min ) ) + this.min },
            rotateSpeedCoefficient() { return 100 }, // cim vyssie cislo, tym mensia rychlost otacania
            rotateSpeedThreshold() { return 0.1 }, // rychlost, pod ktoru otacanie neklesa
        },
        methods: {
            getRuleta() {
                EventService.getRuleta()
                    .then(response => {
                        this.options = response.data.data
                        this.initRuleta()
                    })
            },

            initRuleta() {
                this.canvas = this.$refs.ruletaCanvas
                this.ctx = this.canvas.getContext("2d");

                this.ruletaWheel = new Image()
                this.ruletaWheel.src = 'assets/img/ruleta/ruletaWheel.png'
                this.ruletaWheel.addEventListener('load', e => this.drawWheel(e.target))
            },

            drawWheel(targetImage) {
                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
                this.ctx.drawImage(targetImage, 0, 0, targetImage.width, targetImage.height)
                this.isDisabled = false
            },

            spinRuleta() {
                //this.claimReward(10)
                this.isDisabled = true
                this.endAngle = this.generateRandomAngle
                this.ruletaInterval = setInterval(this.rotateRuleta, this.fps)
            },

            rotateRuleta() {
                this.ctx.save()
                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
                this.ctx.translate( this.ruletaWheel.width / 2, this.ruletaWheel.height / 2)

                this.currentAngle += this.getRotateSpeed()
                this.ctx.rotate( (Math.PI / 180) * this.currentAngle )
                this.ctx.drawImage(this.ruletaWheel, -this.ruletaWheel.width / 2, -this.ruletaWheel.height / 2, this.ruletaWheel.width, this.ruletaWheel.height)
                this.ctx.restore()

                if ( this.getRotateSpeed() <= this.rotateSpeedThreshold ) {
                    this.stopRotating()
                }
            },

            getRotateSpeed() {
                return ( this.endAngle - this.currentAngle ) / this.rotateSpeedCoefficient
            },

            stopRotating() {
                clearInterval(this.ruletaInterval)
                let finalAngle = 360 - ( this.currentAngle % 360 )
                let index = Math.floor( finalAngle / ( 360 / this.options.length ) )

                let reward = this.options[index]
                //console.log(reward)

                // save winning data to db
                this.claimReward(this.options[index].id)
            },

            claimReward(ruleta_id) {
                EventService.claimReward(this.profil.pouzivatel_id.id, ruleta_id)
                    .then(response => {
                        //console.log(response.data)
                        if (response.data.code == 'success') {
                            this.reward_text  = response.data.data.text
                            this.reward_nazov = response.data.data.nazov
                            this.reward_kusov = response.data.data.kusov
                            this.setRuletaLog()

                        } else {
                            //this.$bvModal.hide('modalRoulette')
                            this.responseType = 'warning'
                            this.responseText = response.data.data
                        }
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },

            setRuletaLog() {
                var ruleta_log_pocet_kusov = this.reward_kusov.replace(/(\(|\)|ks)/g, '')
                var ruleta_log_action      = this.reward_nazov
                if (ruleta_log_action == '') {
                    ruleta_log_action = '(NULL)' // nezískal nič -> buď skús šťastie nabudúce alebo album ak už má všetky veci v albumoch odomknuté
                } else {
                    sessionStorage.setItem("album-kravicky", "refresh")
                    sessionStorage.setItem("album-anatomia", "refresh")
                    sessionStorage.setItem("album-recepty", "refresh")
                }

                EventService.setRuletaLog(this.profil.id, this.profil.pouzivatel_id.id,  ruleta_log_action, parseInt(ruleta_log_pocet_kusov))
                    .then(response => {
                        //console.log(response.data)
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },


            // click
            closeModal() {
                this.$bvModal.hide('modalRoulette')
                if (this.reward_text != '') {
                    this.$emit('updateProfil')
                }
            },
        },
    }
</script>